import React from 'react'
import { $createParagraphNode, $createTextNode, $getRoot } from 'lexical'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import * as R from 'ramda'

import { $createTextVariableNode } from 'components/shared/FormFields/common/Editors/nodes/TextVariableNode/TextVariableNode'
import { splitTemplate } from 'components/shared/FormFields/common/Editors/model'

export const InitialStatePlugin = ({ value, variables }) => {
  const [editor] = useLexicalComposerContext()

  const isInitialLoad = React.useRef(true)

  React.useEffect(() => {
    editor.update(() => {
      const root = $getRoot()

      if (!value || R.equals(isInitialLoad.current, R.F())) {
        return
      }

      if (value) {
        isInitialLoad.current = false
        root.clear()
      }

      const paragraph = $createParagraphNode()

      R.forEach(
        chunk => {
          paragraph.append(
            chunk.type === 'variable'
              ? $createTextVariableNode(chunk.key, chunk.label)
              : $createTextNode(chunk.text),
          )
          root.append(paragraph)
        },
        splitTemplate(value, variables),
      )
    })
  }, [editor, value, variables, isInitialLoad])

  React.useEffect(() => {
    return () => {
      editor.update(() => {
        const root = $getRoot()
        root.clear()
      })
    }
  }, [editor])

  return null
}
